const ROUTES = {
  // auth pages
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verify: '/auth/verify',
    confirmationEmail: '/confirmation/parent/:token',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    confirmationPassword: '/reset-password/parent/:token'
  },

  // logged pages
  dashboard: '/',
  profile: '/profile',
  clinics: '/clinics',
  addClinic: '/clinics/create',
  editClinic: '/clinics/edit',
  referrals: '/referrals',
  addReferral: '/referrals/create',
  editReferral: '/referrals/edit',
  viewReferral: '/referrals/view',
  congratulations: '/congratulations',

  // public
  publicReferral: '/referrals/public',

  // static pages
  terms: '/terms',
  privacy: '/privacy-policy'
}

export default ROUTES
